import { AudiogramGenerateRequestDto } from '../../../../../apps/app/src/modules/fragments/fragment.types';
import { BaseAPIClient } from '../base_client';

export const FragmentsAPI = {
  configUpdate(this: BaseAPIClient, stationId: string, data: any) {
    return this.put(`/fragments/config/${stationId}`, data);
  },

  audiogramGenerate(this: BaseAPIClient, id: string, data: AudiogramGenerateRequestDto) {
    return this.post(`/fragments/${id}/audiogram/generate`, data);
  },

  audiogramSocialExport(this: BaseAPIClient, fragmentId: string, platform: string, data: object) {
    return this.post(`/fragments/${fragmentId}/audiogram/social-export/${platform}`, data);
  },

  audiogramMediaUrl(this: BaseAPIClient, fragmentId: string, variant?: string): Promise<string> {
    return this.get(`/fragments/${fragmentId}/audiogram/media-url`, {
      params: { variant },
    }).then((d) => d.url);
  },

  patchTranscription(this: BaseAPIClient, fragmentId: string, slug: string, data: object) {
    return this.patch(`/pnt/v2/fragments/${slug}/${fragmentId}/wpwords`, data);
  },

  patchTranscriptionSpeaker(this: BaseAPIClient, fragmentId: string, slug: string, data: object) {
    return this.patch(`/pnt/v2/fragments/${slug}/diarize/${fragmentId}`, data);
  },
};
